export const ONBOARDING_SEEN_STORAGE_KEY = 'hc_onboarding_seen';

export function hasSeenOnboarding(): boolean {
  try {
    return localStorage.getItem(ONBOARDING_SEEN_STORAGE_KEY) === '1';
  } catch {
    return true;
  }
}

export function markOnboardingSeen(): void {
  try {
    localStorage.setItem(ONBOARDING_SEEN_STORAGE_KEY, '1');
  } catch {
    /* ignore quota / private mode */
  }
}

export function clearOnboardingSeen(): void {
  try {
    localStorage.removeItem(ONBOARDING_SEEN_STORAGE_KEY);
  } catch {
    /* ignore quota / private mode */
  }
}
